function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useState } from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { SelectionMode } from '.';
import { Stack } from '../Stack';
import { Text } from '../TextField';
import { ListTableDetailsRow } from './ListTableDetailsRow';
import { sortColumns } from './ListTableSort';
import { ShimmeredDetailsList } from './ShimmeredDetailsList';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const listNoItemMessageStyles = {
  root: {
    textAlign: 'center'
  }
};
export function ListTable(props) {
  const [columns, setColumns] = useState(props.columns);
  useEffect(() => {
    const sortedColumns = sortColumns(props.columns, props.sortKey);
    setColumns(sortedColumns);
  }, [props.sortKey, props.columns]);
  const onColumnHeaderClick = (e, column) => {
    e === null || e === void 0 || e.preventDefault();
    const col = column;
    if (!col || !props.onSortChange) {
      return;
    }
    const hasSorting = col.sortDescending && col.sortAscending;
    if (col.isSortDisabled || !hasSorting) return;
    switch (props.sortKey) {
      case undefined:
        props.onSortChange(col.sortAscending || '');
        break;
      case col.sortAscending:
        props.onSortChange(col.sortDescending || '');
        break;
      case col.sortDescending:
        props.onSortChange(undefined);
        break;
      default:
        props.onSortChange(col.sortAscending || '');
    }
  };
  const onRenderItemColumn = (item, _index, column) => {
    if (column !== null && column !== void 0 && column.onRender) {
      return column === null || column === void 0 ? void 0 : column.onRender(item);
    }
    const fieldContent = item[column === null || column === void 0 ? void 0 : column.fieldName];
    return /*#__PURE__*/_jsx(Stack, {
      styles: {
        root: {
          justifyContent: 'center',
          height: '100%'
        }
      },
      children: fieldContent
    });
  };
  const renderDisabledRow = _ref => {
    var _props$rowProps;
    let {
      renderRowProps,
      dataId,
      key
    } = _ref;
    const disabledRowStyles = {
      root: {
        pointerEvents: 'none',
        selectors: {
          '& .ms-DetailsRow-check': {
            opacity: 0.6
          }
        }
      }
    };
    const disabledRowWrapperStyles = {
      root: {
        opacity: 0.6
      }
    };
    renderRowProps.styles = disabledRowStyles;
    return /*#__PURE__*/_jsx(ListTableDetailsRow, {
      renderRowProps: renderRowProps,
      dataId: dataId,
      wrapperStyles: disabledRowWrapperStyles,
      isSelectionOnFieldClickTriggered: (_props$rowProps = props.rowProps) === null || _props$rowProps === void 0 ? void 0 : _props$rowProps.isSelectionOnFieldClickTriggered
    }, key);
  };
  const renderRow = _ref2 => {
    var _props$rowProps2, _props$rowProps3, _props$rowProps4;
    let {
      isStriped,
      renderRowProps,
      dataId,
      key
    } = _ref2;
    const defaultStyles = {
      root: {
        cursor: 'default',
        backgroundColor: !!isStriped && renderRowProps.itemIndex % 2 === 0 ? '#F5F5F5' : '#FFFFFF',
        selectors: {
          ':hover': {
            backgroundColor: props.rowHoverColor
          }
        }
      }
    };
    renderRowProps.styles = mergeStyleSets(defaultStyles, (_props$rowProps2 = props.rowProps) === null || _props$rowProps2 === void 0 ? void 0 : _props$rowProps2.styles);
    return /*#__PURE__*/_jsx(ListTableDetailsRow, {
      renderRowProps: renderRowProps,
      dataId: dataId,
      onDoubleClick: (_props$rowProps3 = props.rowProps) === null || _props$rowProps3 === void 0 ? void 0 : _props$rowProps3.onDoubleClick,
      isSelectionOnFieldClickTriggered: (_props$rowProps4 = props.rowProps) === null || _props$rowProps4 === void 0 ? void 0 : _props$rowProps4.isSelectionOnFieldClickTriggered
    }, key);
  };
  const onRenderRow = renderRowProps => {
    var _props$rowProps5, _props$rowProps6;
    if (!renderRowProps) return null;
    const isRowDisabled = renderRowProps.item.isDisabled;
    const createDataId = (_props$rowProps5 = props.rowProps) === null || _props$rowProps5 === void 0 ? void 0 : _props$rowProps5.createDataId;
    const dataId = createDataId && createDataId(renderRowProps.item);
    const createKey = (_props$rowProps6 = props.rowProps) === null || _props$rowProps6 === void 0 ? void 0 : _props$rowProps6.createKey;
    const key = createKey && createKey(renderRowProps.item);
    if (isRowDisabled) return renderDisabledRow({
      renderRowProps,
      dataId,
      key
    });
    return renderRow({
      renderRowProps,
      isStriped: props.isStriped,
      dataId,
      key
    });
  };
  const onRenderHeader = (headerProps, defaultRender) => {
    if (!defaultRender || !headerProps) return /*#__PURE__*/_jsx(_Fragment, {});
    return /*#__PURE__*/_jsx("div", {
      children: defaultRender(_objectSpread(_objectSpread({}, headerProps), {}, {
        styles: props.headerStyles
      }))
    });
  };
  return /*#__PURE__*/_jsxs(Stack, {
    styles: props.wrapperStyles,
    children: [/*#__PURE__*/_jsx(ShimmeredDetailsList, {
      columns: columns.filter(item => item.isHidden !== true),
      items: props.items,
      enableShimmer: props.isLoading && !props.disableListShimmers,
      shimmerLines: props.shimmerLines || 5,
      onItemInvoked: props.onItemInvoked,
      onRenderRow: props.onRenderRow || onRenderRow,
      onRenderItemColumn: onRenderItemColumn,
      onColumnHeaderClick: onColumnHeaderClick,
      selectionMode: props.selectionMode,
      selection: props.selection,
      selectionPreservedOnEmptyClick: props.selectionPreservedOnEmptyClick,
      onRenderDetailsHeader: props.onRenderDetailsHeader || onRenderHeader,
      dragDropEvents: props.dragDropEvents,
      detailsListStyles: props.detailsListStyles,
      layoutMode: props.layoutMode
    }), /*#__PURE__*/_jsx(Stack.Item, {
      styles: listNoItemMessageStyles,
      children: /*#__PURE__*/_jsx(Text, {
        children: !props.items.length && !props.isLoading && props.noItemsMessage
      })
    })]
  });
}
ListTable.defaultProps = {
  noItemsMessage: 'No data available.',
  selectionMode: SelectionMode.none
};